'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.outletCategoryOverviewComponent = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var outletCategoryOverviewComponent = exports.outletCategoryOverviewComponent = {
    template: require('./outlet-category-overview.html'),
    bindings: {
        categories: '<',
        textFields: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "$state", "Analytics", function controller(common, gettextCatalog, $state, Analytics) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.$state = $state;
        vm.language = window.localStorage.getItem('language');
        vm.$onChanges = bindingChanges;

        function init() {
            common.setTitle(gettextCatalog.getString('OP=OP'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/op=op');
        }

        function bindingChanges(changes) {
            if (changes.textFields) {
                if (changes.textFields.currentValue) {
                    vm.textFields = Object.assign(changes.textFields.currentValue, {
                        topText: (0, _marked2.default)(changes.textFields.currentValue.topText || '')
                    });
                } else {
                    vm.partnership = changes.partnership.currentValue;
                }
            }
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/outlet/outlet-category-overview.js
// module id = 958
// module chunks = 0